import React, { useEffect } from 'react';

const styles = {
  toast: {
    position: 'fixed',
    bottom: 24,
    right: 24,
    padding: '12px 18px',
    borderRadius: 'var(--radius-md)',
    fontFamily: 'var(--font-mono)',
    fontSize: 13,
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    zIndex: 1000,
    animation: 'slideUp 0.25s ease',
    maxWidth: 360,
    lineHeight: 1.5,
  },
  success: {
    background: 'var(--success-bg)',
    border: '1px solid var(--success-border)',
    color: 'var(--success)',
  },
  error: {
    background: 'var(--danger-bg)',
    border: '1px solid var(--danger-border)',
    color: 'var(--danger)',
  },
  info: {
    background: 'var(--brand-dim)',
    border: '1px solid var(--brand-border)',
    color: 'var(--brand)',
  },
};

const ICONS = {
  success: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  ),
  error: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <line x1="15" y1="9" x2="9" y2="15"/>
      <line x1="9" y1="9" x2="15" y2="15"/>
    </svg>
  ),
  info: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <line x1="12" y1="16" x2="12" y2="12"/>
      <line x1="12" y1="8" x2="12.01" y2="8"/>
    </svg>
  ),
};

export default function Toast({ message, type = 'success', onClose }) {
  useEffect(() => {
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  if (!message) return null;

  return (
    <>
      <style>{`@keyframes slideUp { from { opacity:0; transform:translateY(12px); } to { opacity:1; transform:translateY(0); } }`}</style>
      <div style={{ ...styles.toast, ...styles[type] }}>
        {ICONS[type]}
        {message}
      </div>
    </>
  );
}
